"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY () {
        return BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY;
    },
    get BranchHoursResponseSchema () {
        return BranchHoursResponseSchema;
    },
    get BranchHoursUpdateRequestSchema () {
        return BranchHoursUpdateRequestSchema;
    },
    get WeeklyHoursIntervalSchema () {
        return WeeklyHoursIntervalSchema;
    },
    get WeeklyHoursSchema () {
        return WeeklyHoursSchema;
    }
});
const _zod = require("zod");
const _time = require("./time");
const BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY = 4;
const WeeklyHoursIntervalSchema = _zod.z.object({
    weekday: _time.IsoWeekdaySchema,
    start: _time.ClinicTimeSchema,
    end: _time.ClinicTimeSchema
}).strict().refine((interval)=>interval.end > interval.start, {
    message: 'End must be after start.',
    path: [
        'end'
    ]
});
const WeeklyHoursSchema = _zod.z.array(WeeklyHoursIntervalSchema).max(7 * BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY, {
    message: 'Too many intervals.'
}).superRefine((intervals, ctx)=>{
    const perWeekday = new Map();
    for (const interval of intervals){
        perWeekday.set(interval.weekday, (perWeekday.get(interval.weekday) ?? 0) + 1);
    }
    for (const count of perWeekday.values()){
        if (count > BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY) {
            ctx.addIssue({
                code: 'custom',
                message: `A weekday can have at most ${BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY} intervals.`
            });
            return;
        }
    }
    if ((0, _time.findOverlappingWeekday)(intervals) !== null) {
        ctx.addIssue({
            code: 'custom',
            message: 'Intervals on one weekday must not overlap.'
        });
    }
}).transform((intervals)=>[
        ...intervals
    ].sort((a, b)=>a.weekday - b.weekday || a.start.localeCompare(b.start)));
const BranchHoursResponseSchema = _zod.z.object({
    branchId: _zod.z.string().uuid(),
    isSet: _zod.z.boolean(),
    version: _zod.z.number().int().min(0),
    intervals: WeeklyHoursSchema
}).strict();
const BranchHoursUpdateRequestSchema = _zod.z.object({
    version: _zod.z.number({
        message: 'version must be a number.'
    }).int({
        message: 'version must be a whole number.'
    }).min(0, {
        message: 'version must be 0 or more.'
    }),
    intervals: WeeklyHoursSchema
}).strict();
